import React, { useEffect, useState } from 'react';
import { SafeAreaProvider } from 'react-native-safe-area-context';
import { ApplicationProvider as KittenProvider, IconRegistry, useTheme as useThemeHook } from '@ui-kitten/components';
import IconAdapter from './icons/adapter';
export const useTheme = useThemeHook;
const LuxTheming = (props) => {
    const { children, config } = props;
    const [isLoading, setIsLoading] = useState(true);
    const { baseMappings, mappings, theme, loaders = [], } = config;
    const themeProps = {
        ...(baseMappings ? { mapping: baseMappings } : {}),
        customMapping: mappings,
        theme,
    };
    useEffect(() => {
        Promise
            .all(loaders.map(loader => loader()))
            .then(() => { setIsLoading(false); });
    }, []);
    if (isLoading) {
        return null;
    }
    return (<SafeAreaProvider>
      <IconRegistry icons={IconAdapter}/>
      
      <KittenProvider {...themeProps}>
        {children}
      </KittenProvider>
    </SafeAreaProvider>);
};
export default LuxTheming;
//# sourceMappingURL=LuxTheming.js.map